import { ButtonBase } from "@mui/material";
import { googleLogout } from "@react-oauth/google";
import { logout } from "../../services/backend-api";
import { GoogleIcon } from "../Svg";

export const GoogleLogoutButton: React.FC<{ Icon?: any }> = ({ Icon }) => {
  const BtnIcon = Icon || GoogleIcon;

  const onLogout = () => {
    // NOTE for one-tap sign in when logging out:
    // https://developers.google.com/identity/gsi/web/guides/automatic-sign-in-sign-out#sign-out
    googleLogout();
    logout();
  };

  return (
    <ButtonBase
      onClick={onLogout}
      disableRipple
      sx={{ padding: 1, paddingRight: 4 }} // padding to increase the click area
    >
      <BtnIcon /> <span style={{ marginLeft: 8 }}>Log Out</span>
    </ButtonBase>
  );
};
